import {RouteLocationRaw} from 'vue-router'
import {ResourceType} from '@toolify/server/src/models/mongoose/PermissionModel/enum/ResourceType'
import {ResourceTypeDataMap} from '@toolify/client/src/modules/resources/maps/ResourceTypeDataMap'

export type ResourceRouteInfo = {
  route: RouteLocationRaw
  resourceType: ResourceType
  resourceId: string
}

export function getResourceRouteFromValue(
  resourceValue: string,
  workspaceName: string,
): ResourceRouteInfo | null {
  if(!resourceValue) {
    return null
  }

  const [resourceType, resourceId] = resourceValue.split(':')
  if(!resourceType || !resourceId) {
    return null
  }

  const resourceTypeDataFn = ResourceTypeDataMap.get(resourceType as ResourceType)
  if(!resourceTypeDataFn) {
    return null
  }

  const resourceData = resourceTypeDataFn({
    resourceType: resourceType as ResourceType,
    resourceId,
    payload: null!,
  })

  if(resourceData?.link && typeof resourceData.link === 'object' && 'name' in resourceData.link) {
    return {
      route: {
        name: resourceData.link.name,
        params: {
          workspaceName,
          ...(resourceData.link.params || {}),
        },
      },
      resourceType: resourceType as ResourceType,
      resourceId,
    }
  }

  return null
}
